import { Component, Input } from '@angular/core';
import { RadioButtonInterfaceMain } from '../../interfaces/input';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  providers: [FormControl]
})

export class RadioButtonComponent {
  @Input() control: FormControl = new FormControl(1, [Validators.required]);
  @Input() name: string = 'radioGroups';
  @Input() buttons: RadioButtonInterfaceMain = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  }
}
